<template>
    <v-container fill-height fluid pa-0>
        <v-row align="center" justify="center">
            <v-col lg="5" md="6" sm="8" xl="4" xs="12">
                <v-card light v-if="person && personCountry">
                    <v-card-text>
                        <page-heading :text="$t('components.register_info.title')"></page-heading>
                        <div class="mb-4">{{ $t('components.register_info.subtitle') }}</div>
                        <v-form ref="personForm" v-model="personFormIsValid">
                            <v-row align="center" justify="center">
                                <v-col cols="6">
                                    <v-text-field :label="$t('components.register_info.inputs.name_text_field_label')"
                                                  :rules="[(val) => !!val || $t('general.input_required')]"
                                                  outlined
                                                  type="text"
                                                  v-model="person.name"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field
                                        :label="$t('components.register_info.inputs.surname_text_field_label')"
                                        :rules="[(val) => !!val || $t('general.input_required')]"
                                        outlined
                                        type="text"
                                        v-model="person.surname"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row align="center" justify="center">
                                <v-col cols="6">
                                    <v-text-field :label="$t('components.register_info.inputs.email_text_field_label')"
                                                  :rules="[validateRule(person.email, $t('general.input_required')), validateRule(validateEmail(person.email), $t('general.valid_email'))]"
                                                  outlined
                                                  type="text"
                                                  v-model="person.email"
                                                  :disabled="!!person.email_verified_at"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-autocomplete :items="years"
                                                    :label="$t('components.register_info.inputs.yob_select_field_label')"
                                                    :rules="[(val) => !!val || $t('general.input_required')]"
                                                    outlined
                                                    v-model="person.birthyear"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="6">
                                    <v-select :label="$t('components.register_info.inputs.gender_select_field_label')"
                                              :rules="[validateRule(person.gender, $t('general.input_required'))]"
                                              outlined
                                              :items="genders"
                                              item-value="value"
                                              item-text="text"
                                              v-model="person.gender"
                                    ></v-select>
                                </v-col>
                                <v-col cols="6">
                                    <country-select :rules="[(val) => !!val || $t('general.input_required')]"
                                                    :value="personCountry"
                                                    @input="setPersonCountry($event)"
                                    ></country-select>
                                </v-col>
                            </v-row>
                            <!--              <v-row align="center" justify="start">-->
                            <!--                <v-col cols="6">-->
                            <!--                  <country-select :rules="[(val) => !!val || $t('general.input_required')]"-->
                            <!--                                  :value="personCountry"-->
                            <!--                                  @input="setPersonCountry($event)"-->
                            <!--                  ></country-select>-->
                            <!--                </v-col>-->
                            <!--              </v-row>-->
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="pt-0 pb-4 px-4">
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!personFormIsValid"
                               :loading="loading"
                               @click="updatePersonInfo()"
                               color="primary"
                               large
                        >{{$t('general.continue')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import PageHeading from "../../components/framework/PageHeading";
    import CountrySelect from "../../components/framework/general/CountrySelect";
    import moment from 'moment';
    import {ASSESSMENT_STATE_PERSON_INFO} from '../../router/assessmentstate';

    export default {
        components: {
            PageHeading,
            CountrySelect
        },
        name: "PersonInfo",
        data: () => ({
            person: null,
            years: [],
            personCountry: {},
            loading: false,
            personFormIsValid: false
        }),
       computed : {
          genders(){
            return [
              {value: 'male', text: this.$t('bio.gender.male')}, {value: 'female', text: this.$t('bio.gender.female')}
            ];
         }
       },
        methods: {
            updatePersonInfo() {
                if (this.$refs.personForm.validate()) {
                    this.loading = true;
                    this.$store.dispatch('person/updateInfo', this.person)
                        .then(() => {
                            this.$store.dispatch('assessment/updateCurrentState', ASSESSMENT_STATE_PERSON_INFO);
                            this.$router.replace({name: "OrientationVideo"});
                            this.loading = false;
                        })
                        .catch((err) => {
                            console.error(err);
                            this.loading = false;
                        })
                }
            },
            validateRule(condition, message) {
                return condition ? true : message;
            },
            validateEmail(email) {
                // eslint-disable-next-line no-control-regex
                return /(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(email);
            },
            getRelevantYears() {
                let dateStart = moment().subtract(100, 'years'),
                    dateEnd = moment();
                while (dateEnd.diff(dateStart, 'years') >= 16) {
                    this.years.push(dateStart.format('YYYY').toString());
                    dateStart.add(1, 'year')
                }
                this.years.reverse();
            },
            isNumber(evt) {
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 46) {
                    evt.preventDefault();
                } else if (evt.key < 0 || evt.key > 9) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            setPersonCountry(event) {
                this.$set(this.person, 'countryid', event.countryid);
                this.$set(this.person, 'mobile_countrycode', event.countrycode);
                this.$set(this.person, 'country', event);
            }
        },
        mounted() {
            this.person = JSON.parse(JSON.stringify(this.$store.state.assessment.assessment.person));
            this.$nextTick(() => {
                this.$set(this.personCountry, 'countrycode', this.person.mobile_countrycode);
                this.$set(this.personCountry, 'countryid', this.person.countryid);
            });
            if (this.person.birthyear) {
                this.person.birthyear = this.person.birthyear.toString();
            }
            this.getRelevantYears();
        }
    }
</script>

<style>

</style>
